var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffee = function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.73 6.52h-7.3a4.09 4.09 0 0 0-4.09 4.09v7.3A4.09 4.09 0 0 0 6.43 22h7.3a4.09 4.09 0 0 0 4.09-4.09v-7.3a4.09 4.09 0 0 0-4.09-4.09",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.83 10.61v7.66a3.83 3.83 0 0 0 0-7.66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.34 10.61v1.55h15.49v-1.55a4.1 4.1 0 0 0-4.1-4.09h-7.3a4.09 4.09 0 0 0-4.09 4.09",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.08 4.72A.75.75 0 0 1 9.33 4V2a.75.75 0 1 1 1.5 0v2a.74.74 0 0 1-.75.72M6.17 4.72A.75.75 0 0 1 5.42 4V2a.75.75 0 0 1 1.5 0v2a.74.74 0 0 1-.75.72M14 4.82a.76.76 0 0 1-.75-.75v-2a.75.75 0 1 1 1.5 0v2a.75.75 0 0 1-.75.75"
  })));
};
export default SvgCoffee;